import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ModalHapus: false,
    rwanak: {
      id: '',
      sapk: {
        id: null
      },
      NIK: null,
      nama: '',
      tempatLahir: '',
      tglLahir: '',
      aktaMeninggal: null,
      tglMeninggal: null,
      jenisKelamin: '',
      ortu: {
        id: null,
        nama: null,
        jenisAnak: ''
      },
      USER_ID: '',
      NCSISTIME: ''
    }
  },

  mutations: {
    toggleModal(state, value) {
      state.ModalHapus = value
    },
    hapusModal(state, value) {
      state.rwanak = value
    },
  }
})
